// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1C2xl","content":"style__content___3swFF","title-container":"style__title-container___ITqw6","title":"style__title___2kh1J","info":"style__info___3VRF0","info__link":"style__info__link___1NTgY","icon":"style__icon___j0mp4"};


//////////////////
// WEBPACK FOOTER
// ./components/MarketingAdvert/style.scss
// module id = 1381
// module chunks = 0